"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.factoryCookie = void 0;

var _isServer = require("../utils/isServer");

var _RealTimeCookie = require("./RealTimeCookie");

var _Task = require("./Task");

var _useCookie = require("./useCookie");

var factoryCookie = function factoryCookie(Cookie) {
  var RealTimeCookie = (0, _isServer.isServer)() ? new _RealTimeCookie.RealTimeCookiePlug() : new _RealTimeCookie.RealTimeCookie(new _Task.TaskCookieRequestAnimationFrame(Cookie));
  return {
    Cookie,
    RealTimeCookie,
    useCookie: (0, _useCookie.factoryUseCookie)(RealTimeCookie, Cookie)
  };
};

exports.factoryCookie = factoryCookie;